import { render, staticRenderFns } from "./PriceCardImgBig.vue?vue&type=template&id=02465768&scoped=true&"
import script from "./PriceCardImgBig.vue?vue&type=script&lang=js&"
export * from "./PriceCardImgBig.vue?vue&type=script&lang=js&"
import style0 from "./PriceCardImgBig.vue?vue&type=style&index=0&id=02465768&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02465768",
  null
  
)

export default component.exports